import { TFunction } from 'i18next';

export enum VariantTypes {
  VIDEOS = 'videos',
  USERS = 'users',
  CTA_SETS = 'cta-sets',
  CTA_LINKS = 'cta-links',
  TABLE_SCOREBOARD = 'table-scoreboard',
}

export interface IParams {
  from: string;
  to: string;
}

export interface Items {
  id: 'clicks' | 'views' | 'engagements';
  label: string;
}

export const getWidgetTabs = (t: TFunction) => ({
  VARIANTS_VIDEOS: [
    { id: 'views', label: t('Views') },
    { id: 'engagement', label: t('Engagement') },
    { id: 'cta-clicks', label: t('CTA Clicks') },
  ],
  VARIANTS_USERS: [
    { id: 'recorded', label: t('Recorded') },
    { id: 'engagements', label: t('Engagements') },
    { id: 'views', label: t('Views') },
    { id: 'clicks', label: t('Clicks') },
  ],
  VARIANTS_LEADERBOARD: [
    { id: '1', label: t('Service') },
    { id: '2', label: t('Sales') },
  ],
});

export enum WidgetValues {
  VIDEO_DELIVERY = 'VIDEO_DELIVERY',
  VIDEO_ENGAGEMENTS = 'VIDEO_ENGAGEMENTS',
  NEW_VIDEOS = 'NEW_VIDEOS',
  TOP_VIDEOS = 'TOP_VIDEOS',
  TOP_USERS = 'TOP_USERS',
  TOP_CTA_SETS = 'TOP_CTA_SETS',
  TOP_FIVE_USER_COMPARISON = 'TOP_FIVE_USER_COMPARISON',
  VIEWS_BY_VIDEO_TYPE = 'VIEWS_BY_VIDEO_TYPE',
  DEPARTMENTS = 'DEPARTMENTS',
  TOP_CTA_LINKS = 'TOP_CTA_LINKS',
  DELIVERY_METHOD = 'DELIVERY_METHOD',
  VIEW_RATE_BY_DELIVERY_METHOD = 'VIEW_RATE_BY_DELIVERY_METHOD',
  LEADERBOARD = 'LEADERBOARD',
}

export enum WidgetLabels {
  VIDEO_DELIVERY = 'Unique Video Delivery',
  VIDEO_ENGAGEMENTS = 'Video Engagement',
  NEW_VIDEOS = 'New Videos',
  TOP_VIDEOS = 'Top Videos',
  TOP_USERS = 'Top Users',
  TOP_CTA_SETS = 'Top CTA Sets',
  TOP_FIVE_USER_COMPARISON = 'Top Five User Comparison',
  VIEWS_BY_VIDEO_TYPE = 'Views by Video Type',
  DEPARTMENTS = 'Departments',
  TOP_CTA_LINKS = 'Top CTA Links',
  DELIVERY_METHOD = 'Delivery Method',
  VIEW_RATE_BY_DELIVERY_METHOD = 'View Rate by Delivery Method',
  LEADERBOARD = 'Leaderboard',
}

export const getCommonWidgets = (t: TFunction) => [
  { label: t(WidgetLabels.VIDEO_DELIVERY), value: WidgetValues.VIDEO_DELIVERY },
  {
    label: t(WidgetLabels.VIDEO_ENGAGEMENTS),
    value: WidgetValues.VIDEO_ENGAGEMENTS,
  },
  { label: t(WidgetLabels.NEW_VIDEOS), value: WidgetValues.NEW_VIDEOS },
  { label: WidgetLabels.DELIVERY_METHOD, value: WidgetValues.DELIVERY_METHOD },
  {
    label: t(WidgetLabels.VIEW_RATE_BY_DELIVERY_METHOD),
    value: WidgetValues.VIEW_RATE_BY_DELIVERY_METHOD,
  },
  { label: t(WidgetLabels.TOP_VIDEOS), value: WidgetValues.TOP_VIDEOS },
  { label: t(WidgetLabels.TOP_USERS), value: WidgetValues.TOP_USERS },
  { label: t(WidgetLabels.TOP_CTA_SETS), value: WidgetValues.TOP_CTA_SETS },
  {
    label: t(WidgetLabels.TOP_FIVE_USER_COMPARISON),
    value: WidgetValues.TOP_FIVE_USER_COMPARISON,
  },
  { label: t(WidgetLabels.DEPARTMENTS), value: WidgetValues.DEPARTMENTS },
  { label: t(WidgetLabels.TOP_CTA_LINKS), value: WidgetValues.TOP_CTA_LINKS },
];

export const getAutomotiveWidgets = (t: TFunction) => [
  ...getCommonWidgets(t),
  {
    label: t(WidgetLabels.VIEWS_BY_VIDEO_TYPE),
    value: WidgetValues.VIEWS_BY_VIDEO_TYPE,
  },
  { label: t(WidgetLabels.LEADERBOARD), value: WidgetValues.LEADERBOARD },
];

export const getDefaultWidgets = (t: TFunction) => [
  {
    label: t(WidgetLabels.VIDEO_ENGAGEMENTS),
    value: WidgetValues.VIDEO_ENGAGEMENTS,
  },
  {
    label: t(WidgetLabels.VIDEO_DELIVERY),
    value: WidgetValues.VIDEO_DELIVERY,
  },
  {
    label: t(WidgetLabels.TOP_VIDEOS),
    value: WidgetValues.TOP_VIDEOS,
  },
  {
    label: t(WidgetLabels.TOP_CTA_SETS),
    value: WidgetValues.TOP_CTA_SETS,
  },
  {
    label: t(WidgetLabels.TOP_USERS),
    value: WidgetValues.TOP_USERS,
  },
];

export interface IDepartmentsWidget {
  views: CtaClick[] | [];
  'cta-clicks': CtaClick[] | [];
  engagement: CtaClick[] | [];
}

export type IDepartmentsWidgetKeys = keyof IDepartmentsWidget;

export interface CtaClick {
  name: string;
  cnt: string;
}

export interface Field {
  value: string;
  label: string;
}

interface VariantProps {
  label: string;
  tabItems: { id: string; label: string }[];
  tableHeaders: string[];
  flexHeaders: string[];
}

export interface VariantData {
  [key: string]: VariantProps;
}

export const REPORTS_STALE_TIME = 1000 * 60 * 4;
